import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";
import { CategoryTypes } from "modules/categories";
import { useSearchParams } from "react-router-dom";

import { requestGetProductsFilterMeta } from "./getProductsFilterMeta.request";
import { getProductsFilterMetaResponse } from "./getProductsFilterMeta.types";

const useGetProductsFilterMeta = (
  options?: QueryOptions<
    getProductsFilterMetaResponse,
    ApiServiceError<ApiError>
  >
) => {
  const [searchParams] = useSearchParams();
  const selectedSubChildCategory = searchParams.get(
    CategoryTypes.SUB_CHILD_CATEGORY
  );

  const { data: filterMeta, ...rest } = useQuery({
    queryKey: ["products", "admin", "one", selectedSubChildCategory],
    queryFn: async () => {
      return await requestGetProductsFilterMeta(
        selectedSubChildCategory as string
      );
    },
    enabled: !!selectedSubChildCategory,
    ...options
  });

  return { filterMeta, ...rest };
};

export default useGetProductsFilterMeta;
